import {ChatApiInterface} from "../api/interface/chat";
import type {ChatResponse} from "../api/payload-types/chat";
import {selectCredentials} from "./authSlice";
import type {RevaThunkAction} from "./revaHooks";

/**
 * Schickt eine Chat-Nachricht an die KI und liefert deren Antwort. Der Verlauf lebt im Component-State der
 * aufrufenden Seite, daher kein Slice. Fehler (`ErrorI18n` aus {@link ChatApiInterface}) reicht der Thunk durch,
 * die Seite zeigt sie an.
 * @param message die Nachricht des Nutzers
 * @returns die Antwort der KI samt `truncated`-Flag
 */
export const sendChatMessageThunk =
    (message: string): RevaThunkAction<Promise<ChatResponse>> =>
    async (_dispatch, getState, {serviceApi}) => {
        const credentials = selectCredentials(getState());
        return new ChatApiInterface(message).execute(serviceApi, credentials!);
    };
